{
  "zones": {
    "summit": {
      "groundColor": "#e8eef2",
      "marksKey": null,
      "baseSurface": "snow",
      "trail": null,
      "spawnTable": [
        { "key": "rock_large", "weight": 3 },
        { "key": "rock_small", "weight": 4 },
        { "key": "warning_sign", "weight": 1 }
      ],
      "setPieces": [],
      "ambience": "amb_summit"
    },
    "scree": {
      "groundColor": "#a39b8b",
      "marksKey": null,
      "baseSurface": "gravel",
      "trail": { "surface": "dirt", "width": 2, "wiggle": 6 },
      "spawnTable": [
        { "key": "rock_large", "weight": 4 },
        { "key": "rock_small", "weight": 5 },
        { "key": "outcrop", "weight": 2 },
        { "key": "gravel", "weight": 3 },
        { "key": "wildlife", "weight": 1, "variant": "marmot" }
      ],
      "setPieces": ["rock_garden"],
      "ambience": "amb_scree"
    },
    "meadow": {
      "groundColor": "#7cb342",
      "marksKey": "marks_meadow",
      "baseSurface": "grass",
      "trail": { "surface": "dirt", "width": 3, "wiggle": 8 },
      "spawnTable": [
        { "key": "rock_small", "weight": 5 },
        { "key": "rock_large", "weight": 2 },
        { "key": "bush", "weight": 4 },
        { "key": "fence", "weight": 1 },
        { "key": "hay_bale", "weight": 1 },
        { "key": "roller", "weight": 2 },
        { "key": "mud", "weight": 1 },
        { "key": "puddle", "weight": 1 },
        { "key": "kicker", "weight": 1 },
        { "key": "hiker", "weight": 1 },
        { "key": "dog", "weight": 1 },
        { "key": "wildlife", "weight": 2, "variant": "cow" },
        { "key": "wildlife", "weight": 1, "variant": "sheep" }
      ],
      "setPieces": ["jump_line", "chairlift", "fence_gap", "berm_series"],
      "ambience": "amb_meadow"
    },
    "forest": {
      "groundColor": "#4e6b3a",
      "marksKey": "marks_forest",
      "baseSurface": "dirt",
      "trail": { "surface": "dirt", "width": 2.5, "wiggle": 10 },
      "spawnTable": [
        { "key": "pine_small", "weight": 5 },
        { "key": "pine_large", "weight": 4 },
        { "key": "tree_leafy", "weight": 2 },
        { "key": "stump", "weight": 2 },
        { "key": "log", "weight": 2 },
        { "key": "fern", "weight": 3 },
        { "key": "roots", "weight": 2 },
        { "key": "mud", "weight": 2 },
        { "key": "tabletop", "weight": 1 },
        { "key": "hiker", "weight": 1 },
        { "key": "npc_rider", "weight": 1 },
        { "key": "wildlife", "weight": 1, "variant": "deer" }
      ],
      "setPieces": ["tree_wall_gap", "log_line", "berm_series"],
      "ambience": "amb_forest"
    },
    "valley": {
      "groundColor": "#a1887f",
      "marksKey": null,
      "baseSurface": "dirt",
      "trail": { "surface": "dirt", "width": 4, "wiggle": 4 },
      "spawnTable": [
        { "key": "fence", "weight": 3 },
        { "key": "stump", "weight": 2 },
        { "key": "hay_bale", "weight": 2 }
      ],
      "setPieces": [],
      "ambience": "amb_valley"
    }
  },
  "surfaces": {
    "dirt":   { "grip": 1.0,  "speedMod": 1.0,  "drag": 0, "rough": 0,   "spray": "#a1745a", "sound": "ride_dirt",   "haptic": "smooth" },
    "grass":  { "grip": 0.85, "speedMod": 0.85, "drag": 0.5, "rough": 0, "spray": "#8bc34a", "sound": "ride_grass",  "haptic": "soft" },
    "mud":    { "grip": 0.5,  "speedMod": 0.55, "drag": 3, "rough": 0,   "spray": "#5d4037", "sound": "ride_mud",    "haptic": "squelch" },
    "gravel": { "grip": 0.6,  "speedMod": 0.85, "drag": 1, "rough": 0.5,   "spray": "#9e9e9e", "sound": "ride_gravel", "haptic": "rattle" },
    "roots":  { "grip": 0.7,  "speedMod": 0.7,  "drag": 1.5, "rough": 1, "spray": "#795548", "sound": "ride_dirt",   "haptic": "bumpy" },
    "rock":   { "grip": 0.75, "speedMod": 0.7,  "drag": 2, "rough": 2,   "spray": "#757575", "sound": "ride_gravel", "haptic": "bumpy" },
    "snow":   { "grip": 0.55, "speedMod": 0.7,  "drag": 1.5, "rough": 0, "spray": "#ffffff", "sound": "ride_grass",  "haptic": "soft" },
    "ice":    { "grip": 0.25, "speedMod": 1.0,  "drag": 0, "rough": 0,   "spray": "#cfe8f5", "sound": "freewheel",   "haptic": "smooth" },
    "wood":   { "grip": 0.9,  "speedMod": 1.05, "drag": 0, "rough": 0,   "spray": "#c49a6c", "sound": "skinny_loop", "haptic": "clatter" }
  }
}
